.info {
	grid-row: 1 / 2;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.info > * {
	font-size: 0.8rem;
	color: var(--textPrimaryHover);
}

.title {
	display: flex;
	grid-row: 2 / 3;
	background-color: var(--depth2);
	border-radius: var(--roundedBig);
	padding: 0.5rem;
	width: 100%;
	height: fit-content;
	font-weight: bold;
	word-break: break-word;
}

.body {
	grid-row: 3 / 4;
	width: 100%;
	height: 100%;
	padding: 0.5rem;
	background-color: var(--depth2);
	border-radius: var(--roundedBig);
	text-align: left;
	word-break: break-word;
}

.footer {
	grid-row: 4 / 5;
}
.footer .multiSelect {
	width: 100%;
}
.multiSelect > div > ul {
	flex-wrap: wrap;
	overflow-y: auto;
	max-width: 29rem;
}
.box {
	background-color: var(--depth1);
	transition-duration: var(--transitionSpeedFast);
	width: 40rem;
	height: fit-content;
}
.wrapper {
	border-radius: var(--roundedBig);
	cursor: pointer;
	height: fit-content;
	width: fit-content;
}
.wrapper:hover .body {
	background-color: var(--depth3);
}
.wrapper:hover .title {
	background-color: var(--depth3);
}
.wrapper:hover .box {
	background-color: var(--depth2);
	width: 100%;
}

.actions {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	justify-content: flex-end;
}
.cancelButton {
	background-color: var(--red) !important;
}
.multiSelect {
	width: 100%;
}
